import { MapPoint } from '@/domain/kart/MapPoint';
import { MapLayerType } from '@/components/map/map-utils/WebMapTileServices';
import { Kartutsnitt } from '@/domain/kart/Kartutsnitt';
import { MapQueries } from '@/middleware/queries';

export class MapState {
    constructor(
        readonly mapLayer: MapLayerType = MapLayerType.STANDARD,
        readonly center: [number, number] = [600000, 7225000],
        readonly zoom: number = 3,
        readonly kartutsnitt: Kartutsnitt | null = null,
        readonly zoomToExtent: Kartutsnitt | null = null,
        readonly points: MapPoint[] = []
    ) {}

    override(modifyObject: { [P in keyof MapState]?: MapState[P] }): MapState {
        return Object.assign(Object.create(MapState.prototype), {
            ...this,
            ...modifyObject,
        });
    }

    withCenterAndZoom(center: [number, number], zoom: number): MapState {
        return this.override({ center, zoom });
    }

    withKartutsnitt(kartutsnitt: Kartutsnitt | null): MapState {
        return this.override({ kartutsnitt });
    }

    withMapLayer(mapLayer: MapLayerType) {
        return this.override({ mapLayer });
    }

    withZoomToExtent(zoomToExtent: Kartutsnitt | null): MapState {
        return this.override({ zoomToExtent });
    }

    withPoints(points: MapPoint[]): MapState {
        return this.override({ points });
    }

    toQueries(): MapQueries {
        return new MapQueries(this.kartutsnitt?.toQueryString());
    }
}
